/**
 * Response parsing utilities for Google Play API
 */

import { ResponseWrapper } from "../gen_proto/googleplay_pb";

export function parseResponse(response: string): Record<string, string> {
    const result: Record<string, string> = {};
    for (const line of response.split("\n")) {
        const keyVal = line.split("=", 2);
        if (keyVal.length >= 2 && keyVal[0] && keyVal[1]) {
            result[keyVal[0]] = keyVal[1];
        }
    }
    return result;
}

export async function unmarshalResponseWrapper(data: Buffer): Promise<ResponseWrapper> {
    return ResponseWrapper.fromBinary(data);
}

export async function marshalRequest(request: ResponseWrapper): Promise<Buffer> {
    return Buffer.from(request.toBinary());
}

export function createAuthParams(
    gsfId?: string,
    sdkVersion?: number,
    email?: string,
    googleServices?: number
): URLSearchParams {
    const params = new URLSearchParams();
    
    if (gsfId) {
        params.set("androidId", gsfId);
    }
    if (sdkVersion) {
        params.set("sdk_version", sdkVersion.toString());
    }
    if (email) {
        params.set("Email", email);
    }
    if (googleServices) {
        params.set("google_play_services_version", googleServices.toString());
    }
    
    params.set("device_country", "us");
    params.set("lang", "en-gb");
    params.set("callerSig", "38918a453d07199354f8b19af05ec6562ced5788");
    
    return params;
}

export function setOAuthParams(params: URLSearchParams, aasToken: string): void {
    params.set("Token", aasToken);
    params.set("app", "com.android.vending");
    params.set("client_sig", "38918a453d07199354f8b19af05ec6562ced5788");
    params.set("callerPkg", "com.google.android.gms");
    params.set("oauth2_foreground", "1");
    params.set("check_email", "1");
    params.set("system_partition", "1");
    params.set("token_request_options", "CAA4AVAB");
}